//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export interface IUserClient {
    getAddresses(cityName?: string | null | undefined, street?: string | null | undefined, unusualBusinessActivityLocation?: string | null | undefined, addressType?: AddressType | undefined, pagingOptions_PageSize?: number | null | undefined, pagingOptions_PageNumber?: number | null | undefined, sortingOptions_SortBy?: SortableAddressField | null | undefined, sortingOptions_SortDirection?: SortDirection | null | undefined,  cancelToken?: CancelToken): Promise<EntityUserAddressesQuery_QueryResult>;
    getAddressesCities(addressType?: AddressType | undefined,  cancelToken?: CancelToken): Promise<EntityUserAddressesCitiesQuery_QueryResult>;
    getUserBankAccounts(query: BankAccountsForDocumentQuery_Query,  cancelToken?: CancelToken): Promise<BankAccountsForDocumentQuery_QueryResult>;
    getBankAccounts(bankAccount?: string | null | undefined, swift?: string | null | undefined, currencyCode?: string | null | undefined, pagingOptions_PageSize?: number | null | undefined, pagingOptions_PageNumber?: number | null | undefined, sortingOptions_SortBy?: SortableBankAccountsField | null | undefined, sortingOptions_SortDirection?: SortDirection | null | undefined,  cancelToken?: CancelToken): Promise<EntityUserBankAccountsQuery_QueryResult>;
    getBankAccountsCurrencies( cancelToken?: CancelToken): Promise<EntityUserBankAccountsCurrenciesQuery_QueryResult>;
    getBusinessActivities(textSearch?: string | null | undefined, pagingOptions_PageSize?: number | null | undefined, pagingOptions_PageNumber?: number | null | undefined, sortingOptions_SortBy?: SortableBusinessActivitiesField | null | undefined, sortingOptions_SortDirection?: SortDirection | null | undefined,  cancelToken?: CancelToken): Promise<UserBusinessActivitiesQuery_QueryResult>;
    getBusinessActivity( cancelToken?: CancelToken): Promise<UserBusinessActivityQuery_QueryResult>;
    getBusinessPartners(textSearch?: string | null | undefined, pagingOptions_PageSize?: number | null | undefined, pagingOptions_PageNumber?: number | null | undefined, sortingOptions_SortBy?: SortableBusinessPartnerField | null | undefined, sortingOptions_SortDirection?: SortDirection | null | undefined,  cancelToken?: CancelToken): Promise<EntityUserBusinessPartnersQuery_QueryResult>;
    /**
     * @return For MobileApp
    or
     */
    getUserDetails( cancelToken?: CancelToken): Promise<UserDetailsQuery_QueryResult>;
    getLanguage( cancelToken?: CancelToken): Promise<UserLanguageQuery_QueryResult>;
    setLanguage(command: UserLanguageUpdate_Command,  cancelToken?: CancelToken): Promise<UserLanguageUpdate_CommandResult>;
    checkUserAuthorization( cancelToken?: CancelToken): Promise<UserCheckAuthorization_CommandResult>;
    getUserOrganizationAddresses(wip?: number | null | undefined, cityName?: string | null | undefined, street?: string | null | undefined, unusualBusinessActivityLocation?: string | null | undefined, pagingOptions_PageSize?: number | null | undefined, pagingOptions_PageNumber?: number | null | undefined, sortingOptions_SortBy?: SortableAddressField | null | undefined, sortingOptions_SortDirection?: SortDirection | null | undefined,  cancelToken?: CancelToken): Promise<UserOrganizationAddressesQuery_QueryResult>;
    getUserOrganizationAdressesCities(wip?: number | undefined,  cancelToken?: CancelToken): Promise<UserOrganizationAddressesCitiesQuery_QueryResult>;
    getUserOrganizationBankAccounts(nip?: string | null | undefined, bankAccount?: string | null | undefined, swift?: string | null | undefined, currencyCode?: string | null | undefined, pagingOptions_PageSize?: number | null | undefined, pagingOptions_PageNumber?: number | null | undefined, sortingOptions_SortBy?: SortableBankAccountsField | null | undefined, sortingOptions_SortDirection?: SortDirection | null | undefined,  cancelToken?: CancelToken): Promise<UserOrganizationBankAccountsQuery_QueryResult>;
    getUserOrganizationBankAccountsCurrencies(nip?: string | null | undefined,  cancelToken?: CancelToken): Promise<UserOrganizationBankAccountsCurrenciesQuery_QueryResult>;
    getUserOrganizationDetails(wip?: number | undefined,  cancelToken?: CancelToken): Promise<UserOrganizationDetailsQuery_QueryResult>;
    getUserOrganizations( cancelToken?: CancelToken): Promise<UserOrganizations_QueryResult>;
    getUserOrganizationsBusinessPartners(organizationNip?: string | null | undefined, nip?: string | null | undefined, textSearch?: string | null | undefined, pagingOptions_PageSize?: number | null | undefined, pagingOptions_PageNumber?: number | null | undefined, sortingOptions_SortBy?: SortableBusinessPartnerField | null | undefined, sortingOptions_SortDirection?: SortDirection | null | undefined,  cancelToken?: CancelToken): Promise<UserOrganizationBusinessPartnersQuery_QueryResult>;
    validate(query: ValidateUserQuery_Query,  cancelToken?: CancelToken): Promise<ValidateUserQuery_QueryResult>;
    validateTaxIdentifier(query: ValidateTaxIdQuery_Query,  cancelToken?: CancelToken): Promise<ValidateTaxIdQuery_QueryResult>;
    updateShortcuts(command: MobileUpdateShortcuts_Command,  cancelToken?: CancelToken): Promise<MobileUpdateShortcuts_CommandResult>;
    checkUserAuthorization2( cancelToken?: CancelToken): Promise<UserCheckAuthorization_CommandResult2>;
}

export class UserClient implements IUserClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getAddresses(cityName?: string | null | undefined, street?: string | null | undefined, unusualBusinessActivityLocation?: string | null | undefined, addressType?: AddressType | undefined, pagingOptions_PageSize?: number | null | undefined, pagingOptions_PageNumber?: number | null | undefined, sortingOptions_SortBy?: SortableAddressField | null | undefined, sortingOptions_SortDirection?: SortDirection | null | undefined, cancelToken?: CancelToken): Promise<EntityUserAddressesQuery_QueryResult> {
        let url_ = this.baseUrl + "/v1/user/addresses?";
        if (cityName !== undefined && cityName !== null)
            url_ += "CityName=" + encodeURIComponent("" + cityName) + "&";
        if (street !== undefined && street !== null)
            url_ += "Street=" + encodeURIComponent("" + street) + "&";
        if (unusualBusinessActivityLocation !== undefined && unusualBusinessActivityLocation !== null)
            url_ += "UnusualBusinessActivityLocation=" + encodeURIComponent("" + unusualBusinessActivityLocation) + "&";
        if (addressType === null)
            throw new globalThis.Error("The parameter 'addressType' cannot be null.");
        else if (addressType !== undefined)
            url_ += "AddressType=" + encodeURIComponent("" + addressType) + "&";
        if (pagingOptions_PageSize !== undefined && pagingOptions_PageSize !== null)
            url_ += "PagingOptions.PageSize=" + encodeURIComponent("" + pagingOptions_PageSize) + "&";
        if (pagingOptions_PageNumber !== undefined && pagingOptions_PageNumber !== null)
            url_ += "PagingOptions.PageNumber=" + encodeURIComponent("" + pagingOptions_PageNumber) + "&";
        if (sortingOptions_SortBy !== undefined && sortingOptions_SortBy !== null)
            url_ += "SortingOptions.SortBy=" + encodeURIComponent("" + sortingOptions_SortBy) + "&";
        if (sortingOptions_SortDirection !== undefined && sortingOptions_SortDirection !== null)
            url_ += "SortingOptions.SortDirection=" + encodeURIComponent("" + sortingOptions_SortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAddresses(_response);
        });
    }

    protected processGetAddresses(response: AxiosResponse): Promise<EntityUserAddressesQuery_QueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 =  response.data ;
            return Promise.resolve<EntityUserAddressesQuery_QueryResult>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 =  response.data ;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 =  response.data ;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EntityUserAddressesQuery_QueryResult>(null as any);
    }

    getAddressesCities(addressType?: AddressType | undefined, cancelToken?: CancelToken): Promise<EntityUserAddressesCitiesQuery_QueryResult> {
        let url_ = this.baseUrl + "/v1/user/addresses-cities?";
        if (addressType === null)
            throw new globalThis.Error("The parameter 'addressType' cannot be null.");
        else if (addressType !== undefined)
            url_ += "AddressType=" + encodeURIComponent("" + addressType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAddressesCities(_response);
        });
    }

    protected processGetAddressesCities(response: AxiosResponse): Promise<EntityUserAddressesCitiesQuery_QueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 =  response.data ;
            return Promise.resolve<EntityUserAddressesCitiesQuery_QueryResult>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 =  response.data ;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 =  response.data ;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EntityUserAddressesCitiesQuery_QueryResult>(null as any);
    }

    getUserBankAccounts(query: BankAccountsForDocumentQuery_Query, cancelToken?: CancelToken): Promise<BankAccountsForDocumentQuery_QueryResult> {
        let url_ = this.baseUrl + "/v1/user/bank-accounts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserBankAccounts(_response);
        });
    }

    protected processGetUserBankAccounts(response: AxiosResponse): Promise<BankAccountsForDocumentQuery_QueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 =  response.data ;
            return Promise.resolve<BankAccountsForDocumentQuery_QueryResult>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 =  response.data ;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BankAccountsForDocumentQuery_QueryResult>(null as any);
    }

    getBankAccounts(bankAccount?: string | null | undefined, swift?: string | null | undefined, currencyCode?: string | null | undefined, pagingOptions_PageSize?: number | null | undefined, pagingOptions_PageNumber?: number | null | undefined, sortingOptions_SortBy?: SortableBankAccountsField | null | undefined, sortingOptions_SortDirection?: SortDirection | null | undefined, cancelToken?: CancelToken): Promise<EntityUserBankAccountsQuery_QueryResult> {
        let url_ = this.baseUrl + "/v1/user/bankaccounts?";
        if (bankAccount !== undefined && bankAccount !== null)
            url_ += "BankAccount=" + encodeURIComponent("" + bankAccount) + "&";
        if (swift !== undefined && swift !== null)
            url_ += "Swift=" + encodeURIComponent("" + swift) + "&";
        if (currencyCode !== undefined && currencyCode !== null)
            url_ += "CurrencyCode=" + encodeURIComponent("" + currencyCode) + "&";
        if (pagingOptions_PageSize !== undefined && pagingOptions_PageSize !== null)
            url_ += "PagingOptions.PageSize=" + encodeURIComponent("" + pagingOptions_PageSize) + "&";
        if (pagingOptions_PageNumber !== undefined && pagingOptions_PageNumber !== null)
            url_ += "PagingOptions.PageNumber=" + encodeURIComponent("" + pagingOptions_PageNumber) + "&";
        if (sortingOptions_SortBy !== undefined && sortingOptions_SortBy !== null)
            url_ += "SortingOptions.SortBy=" + encodeURIComponent("" + sortingOptions_SortBy) + "&";
        if (sortingOptions_SortDirection !== undefined && sortingOptions_SortDirection !== null)
            url_ += "SortingOptions.SortDirection=" + encodeURIComponent("" + sortingOptions_SortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBankAccounts(_response);
        });
    }

    protected processGetBankAccounts(response: AxiosResponse): Promise<EntityUserBankAccountsQuery_QueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 =  response.data ;
            return Promise.resolve<EntityUserBankAccountsQuery_QueryResult>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 =  response.data ;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 =  response.data ;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EntityUserBankAccountsQuery_QueryResult>(null as any);
    }

    getBankAccountsCurrencies( cancelToken?: CancelToken): Promise<EntityUserBankAccountsCurrenciesQuery_QueryResult> {
        let url_ = this.baseUrl + "/v1/user/bankaccounts-currencies";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBankAccountsCurrencies(_response);
        });
    }

    protected processGetBankAccountsCurrencies(response: AxiosResponse): Promise<EntityUserBankAccountsCurrenciesQuery_QueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 =  response.data ;
            return Promise.resolve<EntityUserBankAccountsCurrenciesQuery_QueryResult>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 =  response.data ;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 =  response.data ;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EntityUserBankAccountsCurrenciesQuery_QueryResult>(null as any);
    }

    getBusinessActivities(textSearch?: string | null | undefined, pagingOptions_PageSize?: number | null | undefined, pagingOptions_PageNumber?: number | null | undefined, sortingOptions_SortBy?: SortableBusinessActivitiesField | null | undefined, sortingOptions_SortDirection?: SortDirection | null | undefined, cancelToken?: CancelToken): Promise<UserBusinessActivitiesQuery_QueryResult> {
        let url_ = this.baseUrl + "/v1/user/business-activities?";
        if (textSearch !== undefined && textSearch !== null)
            url_ += "TextSearch=" + encodeURIComponent("" + textSearch) + "&";
        if (pagingOptions_PageSize !== undefined && pagingOptions_PageSize !== null)
            url_ += "PagingOptions.PageSize=" + encodeURIComponent("" + pagingOptions_PageSize) + "&";
        if (pagingOptions_PageNumber !== undefined && pagingOptions_PageNumber !== null)
            url_ += "PagingOptions.PageNumber=" + encodeURIComponent("" + pagingOptions_PageNumber) + "&";
        if (sortingOptions_SortBy !== undefined && sortingOptions_SortBy !== null)
            url_ += "SortingOptions.SortBy=" + encodeURIComponent("" + sortingOptions_SortBy) + "&";
        if (sortingOptions_SortDirection !== undefined && sortingOptions_SortDirection !== null)
            url_ += "SortingOptions.SortDirection=" + encodeURIComponent("" + sortingOptions_SortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBusinessActivities(_response);
        });
    }

    protected processGetBusinessActivities(response: AxiosResponse): Promise<UserBusinessActivitiesQuery_QueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 =  response.data ;
            return Promise.resolve<UserBusinessActivitiesQuery_QueryResult>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 =  response.data ;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 =  response.data ;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserBusinessActivitiesQuery_QueryResult>(null as any);
    }

    getBusinessActivity( cancelToken?: CancelToken): Promise<UserBusinessActivityQuery_QueryResult> {
        let url_ = this.baseUrl + "/v1/user/business-activity";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBusinessActivity(_response);
        });
    }

    protected processGetBusinessActivity(response: AxiosResponse): Promise<UserBusinessActivityQuery_QueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 =  response.data ;
            return Promise.resolve<UserBusinessActivityQuery_QueryResult>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 =  response.data ;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 =  response.data ;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserBusinessActivityQuery_QueryResult>(null as any);
    }

    getBusinessPartners(textSearch?: string | null | undefined, pagingOptions_PageSize?: number | null | undefined, pagingOptions_PageNumber?: number | null | undefined, sortingOptions_SortBy?: SortableBusinessPartnerField | null | undefined, sortingOptions_SortDirection?: SortDirection | null | undefined, cancelToken?: CancelToken): Promise<EntityUserBusinessPartnersQuery_QueryResult> {
        let url_ = this.baseUrl + "/v1/user/business-partners?";
        if (textSearch !== undefined && textSearch !== null)
            url_ += "TextSearch=" + encodeURIComponent("" + textSearch) + "&";
        if (pagingOptions_PageSize !== undefined && pagingOptions_PageSize !== null)
            url_ += "PagingOptions.PageSize=" + encodeURIComponent("" + pagingOptions_PageSize) + "&";
        if (pagingOptions_PageNumber !== undefined && pagingOptions_PageNumber !== null)
            url_ += "PagingOptions.PageNumber=" + encodeURIComponent("" + pagingOptions_PageNumber) + "&";
        if (sortingOptions_SortBy !== undefined && sortingOptions_SortBy !== null)
            url_ += "SortingOptions.SortBy=" + encodeURIComponent("" + sortingOptions_SortBy) + "&";
        if (sortingOptions_SortDirection !== undefined && sortingOptions_SortDirection !== null)
            url_ += "SortingOptions.SortDirection=" + encodeURIComponent("" + sortingOptions_SortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBusinessPartners(_response);
        });
    }

    protected processGetBusinessPartners(response: AxiosResponse): Promise<EntityUserBusinessPartnersQuery_QueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 =  response.data ;
            return Promise.resolve<EntityUserBusinessPartnersQuery_QueryResult>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 =  response.data ;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 =  response.data ;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EntityUserBusinessPartnersQuery_QueryResult>(null as any);
    }

    /**
     * @return For MobileApp
    or
     */
    getUserDetails( cancelToken?: CancelToken): Promise<UserDetailsQuery_QueryResult> {
        let url_ = this.baseUrl + "/v1/user/details";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserDetails(_response);
        });
    }

    protected processGetUserDetails(response: AxiosResponse): Promise<UserDetailsQuery_QueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 =  response.data ;
            return Promise.resolve<UserDetailsQuery_QueryResult>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 =  response.data ;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDetailsQuery_QueryResult>(null as any);
    }

    getLanguage( cancelToken?: CancelToken): Promise<UserLanguageQuery_QueryResult> {
        let url_ = this.baseUrl + "/v1/user/language";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLanguage(_response);
        });
    }

    protected processGetLanguage(response: AxiosResponse): Promise<UserLanguageQuery_QueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 =  response.data ;
            return Promise.resolve<UserLanguageQuery_QueryResult>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 =  response.data ;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 =  response.data ;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserLanguageQuery_QueryResult>(null as any);
    }

    setLanguage(command: UserLanguageUpdate_Command, cancelToken?: CancelToken): Promise<UserLanguageUpdate_CommandResult> {
        let url_ = this.baseUrl + "/v1/user/language";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetLanguage(_response);
        });
    }

    protected processSetLanguage(response: AxiosResponse): Promise<UserLanguageUpdate_CommandResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 =  response.data ;
            return Promise.resolve<UserLanguageUpdate_CommandResult>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 =  response.data ;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 =  response.data ;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserLanguageUpdate_CommandResult>(null as any);
    }

    checkUserAuthorization( cancelToken?: CancelToken): Promise<UserCheckAuthorization_CommandResult> {
        let url_ = this.baseUrl + "/v1/user/user-authorization";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckUserAuthorization(_response);
        });
    }

    protected processCheckUserAuthorization(response: AxiosResponse): Promise<UserCheckAuthorization_CommandResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 =  response.data ;
            return Promise.resolve<UserCheckAuthorization_CommandResult>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 =  response.data ;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 =  response.data ;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserCheckAuthorization_CommandResult>(null as any);
    }

    getUserOrganizationAddresses(wip?: number | null | undefined, cityName?: string | null | undefined, street?: string | null | undefined, unusualBusinessActivityLocation?: string | null | undefined, pagingOptions_PageSize?: number | null | undefined, pagingOptions_PageNumber?: number | null | undefined, sortingOptions_SortBy?: SortableAddressField | null | undefined, sortingOptions_SortDirection?: SortDirection | null | undefined, cancelToken?: CancelToken): Promise<UserOrganizationAddressesQuery_QueryResult> {
        let url_ = this.baseUrl + "/v1/user/user-organization-addresses?";
        if (wip !== undefined && wip !== null)
            url_ += "Wip=" + encodeURIComponent("" + wip) + "&";
        if (cityName !== undefined && cityName !== null)
            url_ += "CityName=" + encodeURIComponent("" + cityName) + "&";
        if (street !== undefined && street !== null)
            url_ += "Street=" + encodeURIComponent("" + street) + "&";
        if (unusualBusinessActivityLocation !== undefined && unusualBusinessActivityLocation !== null)
            url_ += "UnusualBusinessActivityLocation=" + encodeURIComponent("" + unusualBusinessActivityLocation) + "&";
        if (pagingOptions_PageSize !== undefined && pagingOptions_PageSize !== null)
            url_ += "PagingOptions.PageSize=" + encodeURIComponent("" + pagingOptions_PageSize) + "&";
        if (pagingOptions_PageNumber !== undefined && pagingOptions_PageNumber !== null)
            url_ += "PagingOptions.PageNumber=" + encodeURIComponent("" + pagingOptions_PageNumber) + "&";
        if (sortingOptions_SortBy !== undefined && sortingOptions_SortBy !== null)
            url_ += "SortingOptions.SortBy=" + encodeURIComponent("" + sortingOptions_SortBy) + "&";
        if (sortingOptions_SortDirection !== undefined && sortingOptions_SortDirection !== null)
            url_ += "SortingOptions.SortDirection=" + encodeURIComponent("" + sortingOptions_SortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserOrganizationAddresses(_response);
        });
    }

    protected processGetUserOrganizationAddresses(response: AxiosResponse): Promise<UserOrganizationAddressesQuery_QueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 =  response.data ;
            return Promise.resolve<UserOrganizationAddressesQuery_QueryResult>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 =  response.data ;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 =  response.data ;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserOrganizationAddressesQuery_QueryResult>(null as any);
    }

    getUserOrganizationAdressesCities(wip?: number | undefined, cancelToken?: CancelToken): Promise<UserOrganizationAddressesCitiesQuery_QueryResult> {
        let url_ = this.baseUrl + "/v1/user/user-organization-addresses-cities?";
        if (wip === null)
            throw new globalThis.Error("The parameter 'wip' cannot be null.");
        else if (wip !== undefined)
            url_ += "Wip=" + encodeURIComponent("" + wip) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserOrganizationAdressesCities(_response);
        });
    }

    protected processGetUserOrganizationAdressesCities(response: AxiosResponse): Promise<UserOrganizationAddressesCitiesQuery_QueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 =  response.data ;
            return Promise.resolve<UserOrganizationAddressesCitiesQuery_QueryResult>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 =  response.data ;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 =  response.data ;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserOrganizationAddressesCitiesQuery_QueryResult>(null as any);
    }

    getUserOrganizationBankAccounts(nip?: string | null | undefined, bankAccount?: string | null | undefined, swift?: string | null | undefined, currencyCode?: string | null | undefined, pagingOptions_PageSize?: number | null | undefined, pagingOptions_PageNumber?: number | null | undefined, sortingOptions_SortBy?: SortableBankAccountsField | null | undefined, sortingOptions_SortDirection?: SortDirection | null | undefined, cancelToken?: CancelToken): Promise<UserOrganizationBankAccountsQuery_QueryResult> {
        let url_ = this.baseUrl + "/v1/user/user-organization-bankaccounts?";
        if (nip !== undefined && nip !== null)
            url_ += "Nip=" + encodeURIComponent("" + nip) + "&";
        if (bankAccount !== undefined && bankAccount !== null)
            url_ += "BankAccount=" + encodeURIComponent("" + bankAccount) + "&";
        if (swift !== undefined && swift !== null)
            url_ += "Swift=" + encodeURIComponent("" + swift) + "&";
        if (currencyCode !== undefined && currencyCode !== null)
            url_ += "CurrencyCode=" + encodeURIComponent("" + currencyCode) + "&";
        if (pagingOptions_PageSize !== undefined && pagingOptions_PageSize !== null)
            url_ += "PagingOptions.PageSize=" + encodeURIComponent("" + pagingOptions_PageSize) + "&";
        if (pagingOptions_PageNumber !== undefined && pagingOptions_PageNumber !== null)
            url_ += "PagingOptions.PageNumber=" + encodeURIComponent("" + pagingOptions_PageNumber) + "&";
        if (sortingOptions_SortBy !== undefined && sortingOptions_SortBy !== null)
            url_ += "SortingOptions.SortBy=" + encodeURIComponent("" + sortingOptions_SortBy) + "&";
        if (sortingOptions_SortDirection !== undefined && sortingOptions_SortDirection !== null)
            url_ += "SortingOptions.SortDirection=" + encodeURIComponent("" + sortingOptions_SortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserOrganizationBankAccounts(_response);
        });
    }

    protected processGetUserOrganizationBankAccounts(response: AxiosResponse): Promise<UserOrganizationBankAccountsQuery_QueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 =  response.data ;
            return Promise.resolve<UserOrganizationBankAccountsQuery_QueryResult>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 =  response.data ;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 =  response.data ;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserOrganizationBankAccountsQuery_QueryResult>(null as any);
    }

    getUserOrganizationBankAccountsCurrencies(nip?: string | null | undefined, cancelToken?: CancelToken): Promise<UserOrganizationBankAccountsCurrenciesQuery_QueryResult> {
        let url_ = this.baseUrl + "/v1/user/user-organization-bankaccounts-currencies?";
        if (nip !== undefined && nip !== null)
            url_ += "Nip=" + encodeURIComponent("" + nip) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserOrganizationBankAccountsCurrencies(_response);
        });
    }

    protected processGetUserOrganizationBankAccountsCurrencies(response: AxiosResponse): Promise<UserOrganizationBankAccountsCurrenciesQuery_QueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 =  response.data ;
            return Promise.resolve<UserOrganizationBankAccountsCurrenciesQuery_QueryResult>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 =  response.data ;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 =  response.data ;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserOrganizationBankAccountsCurrenciesQuery_QueryResult>(null as any);
    }

    getUserOrganizationDetails(wip?: number | undefined, cancelToken?: CancelToken): Promise<UserOrganizationDetailsQuery_QueryResult> {
        let url_ = this.baseUrl + "/v1/user/user-organization-details?";
        if (wip === null)
            throw new globalThis.Error("The parameter 'wip' cannot be null.");
        else if (wip !== undefined)
            url_ += "Wip=" + encodeURIComponent("" + wip) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserOrganizationDetails(_response);
        });
    }

    protected processGetUserOrganizationDetails(response: AxiosResponse): Promise<UserOrganizationDetailsQuery_QueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 =  response.data ;
            return Promise.resolve<UserOrganizationDetailsQuery_QueryResult>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 =  response.data ;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 =  response.data ;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserOrganizationDetailsQuery_QueryResult>(null as any);
    }

    getUserOrganizations( cancelToken?: CancelToken): Promise<UserOrganizations_QueryResult> {
        let url_ = this.baseUrl + "/v1/user/user-organizations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserOrganizations(_response);
        });
    }

    protected processGetUserOrganizations(response: AxiosResponse): Promise<UserOrganizations_QueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 =  response.data ;
            return Promise.resolve<UserOrganizations_QueryResult>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 =  response.data ;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 =  response.data ;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserOrganizations_QueryResult>(null as any);
    }

    getUserOrganizationsBusinessPartners(organizationNip?: string | null | undefined, nip?: string | null | undefined, textSearch?: string | null | undefined, pagingOptions_PageSize?: number | null | undefined, pagingOptions_PageNumber?: number | null | undefined, sortingOptions_SortBy?: SortableBusinessPartnerField | null | undefined, sortingOptions_SortDirection?: SortDirection | null | undefined, cancelToken?: CancelToken): Promise<UserOrganizationBusinessPartnersQuery_QueryResult> {
        let url_ = this.baseUrl + "/v1/user/user-organizations-business-partners?";
        if (organizationNip !== undefined && organizationNip !== null)
            url_ += "OrganizationNip=" + encodeURIComponent("" + organizationNip) + "&";
        if (nip !== undefined && nip !== null)
            url_ += "Nip=" + encodeURIComponent("" + nip) + "&";
        if (textSearch !== undefined && textSearch !== null)
            url_ += "TextSearch=" + encodeURIComponent("" + textSearch) + "&";
        if (pagingOptions_PageSize !== undefined && pagingOptions_PageSize !== null)
            url_ += "PagingOptions.PageSize=" + encodeURIComponent("" + pagingOptions_PageSize) + "&";
        if (pagingOptions_PageNumber !== undefined && pagingOptions_PageNumber !== null)
            url_ += "PagingOptions.PageNumber=" + encodeURIComponent("" + pagingOptions_PageNumber) + "&";
        if (sortingOptions_SortBy !== undefined && sortingOptions_SortBy !== null)
            url_ += "SortingOptions.SortBy=" + encodeURIComponent("" + sortingOptions_SortBy) + "&";
        if (sortingOptions_SortDirection !== undefined && sortingOptions_SortDirection !== null)
            url_ += "SortingOptions.SortDirection=" + encodeURIComponent("" + sortingOptions_SortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserOrganizationsBusinessPartners(_response);
        });
    }

    protected processGetUserOrganizationsBusinessPartners(response: AxiosResponse): Promise<UserOrganizationBusinessPartnersQuery_QueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 =  response.data ;
            return Promise.resolve<UserOrganizationBusinessPartnersQuery_QueryResult>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 =  response.data ;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 =  response.data ;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserOrganizationBusinessPartnersQuery_QueryResult>(null as any);
    }

    validate(query: ValidateUserQuery_Query, cancelToken?: CancelToken): Promise<ValidateUserQuery_QueryResult> {
        let url_ = this.baseUrl + "/v1/user/validate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidate(_response);
        });
    }

    protected processValidate(response: AxiosResponse): Promise<ValidateUserQuery_QueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 =  response.data ;
            return Promise.resolve<ValidateUserQuery_QueryResult>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 =  response.data ;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValidateUserQuery_QueryResult>(null as any);
    }

    validateTaxIdentifier(query: ValidateTaxIdQuery_Query, cancelToken?: CancelToken): Promise<ValidateTaxIdQuery_QueryResult> {
        let url_ = this.baseUrl + "/v1/user/validate-tax-id";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidateTaxIdentifier(_response);
        });
    }

    protected processValidateTaxIdentifier(response: AxiosResponse): Promise<ValidateTaxIdQuery_QueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 =  response.data ;
            return Promise.resolve<ValidateTaxIdQuery_QueryResult>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 =  response.data ;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValidateTaxIdQuery_QueryResult>(null as any);
    }

    updateShortcuts(command: MobileUpdateShortcuts_Command, cancelToken?: CancelToken): Promise<MobileUpdateShortcuts_CommandResult> {
        let url_ = this.baseUrl + "/v2/user/shortcuts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateShortcuts(_response);
        });
    }

    protected processUpdateShortcuts(response: AxiosResponse): Promise<MobileUpdateShortcuts_CommandResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 =  response.data ;
            return Promise.resolve<MobileUpdateShortcuts_CommandResult>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 =  response.data ;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MobileUpdateShortcuts_CommandResult>(null as any);
    }

    checkUserAuthorization2( cancelToken?: CancelToken): Promise<UserCheckAuthorization_CommandResult2> {
        let url_ = this.baseUrl + "/v2/user/user-authorization";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckUserAuthorization2(_response);
        });
    }

    protected processCheckUserAuthorization2(response: AxiosResponse): Promise<UserCheckAuthorization_CommandResult2> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 =  response.data ;
            return Promise.resolve<UserCheckAuthorization_CommandResult2>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 =  response.data ;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserCheckAuthorization_CommandResult2>(null as any);
    }
}

export interface IUserLoginMethodClient {
    get( cancelToken?: CancelToken): Promise<UserLoginMethodQuery_QueryResult[]>;
    update(command: UserLoginMethodUpdate_Command,  cancelToken?: CancelToken): Promise<UserLoginMethodUpdate_CommandResult>;
}

export class UserLoginMethodClient implements IUserLoginMethodClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    get( cancelToken?: CancelToken): Promise<UserLoginMethodQuery_QueryResult[]> {
        let url_ = this.baseUrl + "/v1/userloginmethod";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<UserLoginMethodQuery_QueryResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 =  response.data ;
            return Promise.resolve<UserLoginMethodQuery_QueryResult[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 =  response.data ;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 =  response.data ;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserLoginMethodQuery_QueryResult[]>(null as any);
    }

    update(command: UserLoginMethodUpdate_Command, cancelToken?: CancelToken): Promise<UserLoginMethodUpdate_CommandResult> {
        let url_ = this.baseUrl + "/v1/userloginmethod";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<UserLoginMethodUpdate_CommandResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 =  response.data ;
            return Promise.resolve<UserLoginMethodUpdate_CommandResult>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 =  response.data ;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserLoginMethodUpdate_CommandResult>(null as any);
    }
}

// >> Types start

export interface UserDetailsQuery_QueryResult {
    pesel?: string | undefined;
    nip?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    dateOfBirth?: string | undefined;
    updatedAt: string;
    email?: string | undefined;
    phone?: string | undefined;
    fax?: string | undefined;
    agreements?: AgreementDto[] | undefined;
    notificationChannels?: ContactDetails[] | undefined;
    bankAccountNumber?: string | undefined;
    bankAccountOwner?: string | undefined;
    bankAccountCountryCode?: string | undefined;
    bankAccountCurrencyCode?: string | undefined;
    hasAnyBankAccountForFiscalRefund?: boolean;
    swift?: string | undefined;
    taxOfficeId?: string | undefined;
    taxOfficeCode?: string | undefined;
    taxOfficeName?: string | undefined;
    pkdName?: string | undefined;
    pkdCode?: string | undefined;
    fatherName?: string | undefined;
    motherName?: string | undefined;
    addresses?: Address[] | undefined;
    electronicAddresses?: string[] | undefined;
    hasBusinessActivity?: boolean;
    bankAccountType?: string | undefined;
    hasBusinessPartners?: boolean;
    userContext?: UserDetailsQuery_QueryResult_QueryResultUserContext | undefined;
    telepinStatus: TelepinStatus;
    mobileContext?: MobileContextDto | undefined;
}

export interface AgreementDto {
    purposeOfConsent: PurposeOfConsent;
    consentIsGiven?: boolean;
    lastUpdateDate?: string | undefined;
}

export enum PurposeOfConsent {
    None = 0,
    ZGD1 = 1,
    ZGD2 = 2,
}

export interface ContactDetails {
    id: string;
    type: ContactType;
    value?: string | undefined;
    displayName?: string | undefined;
    lastEditDate?: string | undefined;
    lastConfirmDate?: string | undefined;
}

export enum ContactType {
    None = 0,
    Email = 1,
    Phone = 2,
}

export interface Address {
    id: number;
    type?: string | undefined;
    typeName?: string | undefined;
    street?: string | undefined;
    houseNumber?: string | undefined;
    apartmentNumber?: string | undefined;
    zipCode?: string | undefined;
    cityId?: string | undefined;
    cityKey?: string | undefined;
    cityName?: string | undefined;
    communityId?: string | undefined;
    communityKey?: string | undefined;
    communityName?: string | undefined;
    countyId?: string | undefined;
    countyKey?: string | undefined;
    countyName?: string | undefined;
    voivodeshipId?: string | undefined;
    voivodeshipKey?: string | undefined;
    voivodeshipName?: string | undefined;
    countryId?: string | undefined;
    countryKey?: string | undefined;
    countryName?: string | undefined;
    fiscalControl?: string | undefined;
    unusualBusinessActivityLocation?: string | undefined;
    isDeliveryAddress?: boolean;
    poBox?: string | undefined;
    validFrom?: string | undefined;
}

export interface UserDetailsQuery_QueryResult_QueryResultUserContext {
    isNotary?: boolean;
    isNotaryActSite?: boolean;
    representationVariants?: RepresentationVariant[] | undefined;
    hasTaxDeclarationHistory?: boolean;
    isTaxDeclarationHistoryTaxPayer?: boolean;
    isTaxDeclarationHistoryPayer?: boolean;
    isBalancesTaxPayer?: boolean;
    isBalancesPayer?: boolean;
    isKPBalancesTaxPayer?: boolean;
    isPCCBalancesPayer?: boolean;
    isPCCBalancesTaxPayer?: boolean;
    isPITBalancesPayer?: boolean;
    isPITBalancesTaxPayer?: boolean;
    isSDBalancesPayer?: boolean;
    isSDBalancesTaxPayer?: boolean;
    isVATBalancesTaxPayer?: boolean;
    canSubmitZap3?: boolean;
    hasForeignProxies?: boolean;
    hasForeignPrincipals?: boolean;
    pendingPayments?: PendingPaymentDto[] | undefined;
    hasTransactionsSentToRnp?: boolean;
    isForeignUserWithPesel?: boolean;
}

export enum RepresentationVariant {
    None = 0,
    IsPrincipalPPO1 = 101,
    IsPrincipalUPL1 = 102,
    IsPrincipalZASE = 103,
    IsProxyPPO1OfPersonWithPeselOnly = 201,
    IsProxyUPL1OfPersonWithPeselOnly = 202,
    IsProxyZASEOfPersonWithPeselOnly = 203,
    IsProxyPPO1OfPersonWithNipOnly = 301,
    IsProxyUPL1OfPersonWithNipOnly = 302,
    IsProxyZASEOfPersonWithNipOnly = 303,
    IsProxyPPO1OfPersonWithNipAndPesel = 401,
    IsProxyUPL1OfPersonWithNipAndPesel = 402,
    IsProxyZASEOfPersonWithNipAndPesel = 403,
    IsProxyPPO1OfOrganization = 501,
    IsProxyUPL1OfOrganization = 502,
    IsProxyZASEOfOrganization = 503,
    IsProxyUKO = 601,
}

export interface PendingPaymentDto {
    type: PendingPaymentType;
    amount: number;
    translationKey?: string | undefined;
    quantityToPay: number;
}

export enum PendingPaymentType {
    None = 0,
    KPD = 1000,
    PC2 = 1001,
    PCC = 1002,
    PSD = 1003,
    SD2 = 1004,
    PCCP = 1005,
    PCCPP = 1006,
    SDP = 1007,
    SDPP = 1008,
    KPDP = 1009,
    VAT = 1011,
    PIT = 1013,
    PIT2 = 1014,
    PPD = 1017,
    PPE = 1019,
    PPL = 1021,
    PPR = 1023,
    PPR2 = 1024,
    PPW = 1027,
    CIT = 1029,
    CIT2 = 1030,
    DSF = 1033,
    VAT2 = 1043,
    KDWi = 1045,
    TaxFinesPenalties = 1999,
    Tickets = 2000,
}

export enum TelepinStatus {
    Deactivate = 0,
    Active = 1,
    Blocked = 2,
}

export interface MobileContextDto {
    mobileShortcuts?: MobileShortcutsDto | undefined;
}

export interface MobileShortcutsDto {
    userShortcuts?: string[] | undefined;
    organizationShortcuts?: string[] | undefined;
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions: { [key: string]: any; };

    [key: string]: any;
}

export interface UserLanguageQuery_QueryResult {
    language?: string | undefined;
}

export interface BaseResult {
    success?: boolean;
    message?: string | undefined;
}

export interface TranslatedCommandResult extends BaseResult {
}

export interface UserLanguageUpdate_CommandResult extends TranslatedCommandResult {
    result?: string | undefined;
}

export interface UserLanguageUpdate_Command {
    language: string;
}

export interface UserBusinessActivityQuery_QueryResult {
    businessActivity?: UserWithBusinessActivity | undefined;
}

export interface UserWithBusinessActivity {
    id: string;
    nip?: string | undefined;
    regon?: string | undefined;
    hasBusinessActivity?: boolean;
    companyStatus?: string | undefined;
    startDateOfBusinessActivity?: string | undefined;
    pkdName?: string | undefined;
    pkdCode?: string | undefined;
    accountingOfficeInfo?: AccountingOfficeInfo | undefined;
    businessActivityInfo?: BusinessActivityInfo | undefined;
    businessPartnerInfo?: BusinessPartnerInfo | undefined;
    addressInfo?: AddressInfo | undefined;
    bankAccountInfo?: BankAccountInfo | undefined;
}

export interface AccountingOfficeInfo {
    nip?: string | undefined;
    name?: string | undefined;
}

export interface BusinessActivityInfo {
    mainBusinessActivity?: BusinessActivity | undefined;
    hasMore?: boolean;
}

export interface BusinessActivity {
    registeredFullName?: string | undefined;
    registryCode?: string | undefined;
    dateOfRegistry: string;
    isActive?: boolean;
    validTo?: string | undefined;
    registryCodeName?: string | undefined;
    registryOffice?: string | undefined;
}

export interface BusinessPartnerInfo {
    mainBusinessPartner?: BusinessPartner | undefined;
    hasMore?: boolean;
}

export interface BusinessPartner {
    wip: number;
    nip?: string | undefined;
    pesel?: string | undefined;
    validTo?: string | undefined;
    regon?: string | undefined;
    companyName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    connectionType: BusinessPartnerConnectionType;
}

export enum BusinessPartnerConnectionType {
    None = 0,
    Wsp = 1,
    Grk = 2,
    Grv = 3,
    Pgv = 4,
}

export interface AddressInfo {
    mainAddress?: Address[] | undefined;
    hasMore?: boolean;
}

export interface BankAccountInfo {
    mainBankAccount?: UserBankAccount | undefined;
    refundBankAccount?: UserBankAccount | undefined;
    hasMore?: boolean;
}

export interface UserBankAccount {
    type?: string | undefined;
    kind?: string | undefined;
    kindDetailed?: string | undefined;
    owner?: string | undefined;
    number?: string | undefined;
    countryCode?: string | undefined;
    swift?: string | undefined;
    validFrom?: string | undefined;
    validTo?: string | undefined;
    fiscalControl?: string | undefined;
    currencyCode?: string | undefined;
}

export interface UserBusinessActivitiesQuery_QueryResult {
    businessActivities?: BusinessActivity[] | undefined;
}

export enum SortableBusinessActivitiesField {
    DateOfRegistry = 0,
    RegistryCode = 1,
    RegisteredFullName = 2,
    IsActive = 3,
    ValidTo = 4,
}

export enum SortDirection {
    None = 0,
    Asc = 1,
    Desc = 2,
}

export interface EntityUserBankAccountsQuery_QueryResult {
    bankAccounts?: BankAccount[] | undefined;
}

export interface BankAccount {
    type?: string | undefined;
    countryOfBankForTaxReturn?: string | undefined;
    owner?: string | undefined;
    swift?: string | undefined;
    accountNumber?: string | undefined;
    kind?: string | undefined;
    kindDetailed?: string | undefined;
    validFrom?: string | undefined;
    validTo?: string | undefined;
    fiscalControl?: string | undefined;
    currencyCode?: string | undefined;
}

export enum SortableBankAccountsField {
    None = 0,
    ValidFrom = 1,
    Type = 2,
    CountryOfBankForTaxReturn = 3,
    Swift = 4,
    AccountNumber = 5,
    CurrencyCode = 6,
}

export interface EntityUserBankAccountsCurrenciesQuery_QueryResult {
    currencyCodes?: string[] | undefined;
}

export interface EntityUserAddressesQuery_QueryResult {
    addresses?: Address[] | undefined;
}

export enum AddressType {
    None = 0,
    RAD = 1,
    KAD = 2,
    GAD = 3,
    DAD = 4,
    MAD = 5,
    IAD = 6,
    SAD = 7,
    KOR = 8,
    DOR = 9,
    SKR = 10,
}

export enum SortableAddressField {
    ValidFrom = 0,
    Type = 1,
    Street = 2,
    HouseNumber = 3,
    ApartmentNumber = 4,
    ZipCode = 5,
    CityName = 6,
    CommunityName = 7,
    CountyName = 8,
    VoivodeshipName = 9,
    CountryName = 10,
    UnusualBusinessActivityLocation = 11,
}

export interface EntityUserAddressesCitiesQuery_QueryResult {
    citiesNames?: string[] | undefined;
}

export interface EntityUserBusinessPartnersQuery_QueryResult {
    businessPartner?: BusinessPartner[] | undefined;
}

export enum SortableBusinessPartnerField {
    None = 0,
    CompanyName = 1,
    Nip = 2,
    Pesel = 3,
    ValidTo = 4,
    Regon = 5,
    FullName = 6,
    DisplayName = 7,
}

export interface UserCheckAuthorization_CommandResult {
    isInformal?: boolean;
    existsInCrp?: boolean;
    isAliveAndAdult?: boolean;
    isAlive?: boolean;
    isAdult?: boolean;
    loggedInWithTaxData?: boolean;
    loggedInWithEnabledMethod?: boolean;
}

export interface UserOrganizations_QueryResult {
    organizations?: OrganizationSimple[] | undefined;
}

export interface OrganizationSimple {
    wip: number;
    nip?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
}

export interface UserOrganizationDetailsQuery_QueryResult {
    wip: number;
    fullCompanyName?: string | undefined;
    nip?: string | undefined;
    regon?: string | undefined;
    krs?: string | undefined;
    taxOfficeId?: string | undefined;
    taxOfficeName?: string | undefined;
    registryCodeName?: string | undefined;
    registryCode?: string | undefined;
    pkdCode?: string | undefined;
    pkdName?: string | undefined;
    accountingOfficeNip?: string | undefined;
    accountingOfficeName?: string | undefined;
    mainContact?: Contact | undefined;
    mainElectronicAddress?: ElectronicAddressModel | undefined;
    radAddress?: Address | undefined;
    dadAddress?: Address | undefined;
    kadAddress?: Address | undefined;
    skrAddress?: Address | undefined;
    hasMoreDadAddress?: boolean;
    taxReturnBankAccount?: BankAccountBasicInfoWithType | undefined;
    otherBankAccount?: BankAccountMoreInfoWithType | undefined;
    oppBankAccount?: BankAccountBasicInfoWithType | undefined;
    mainBusinessPartner?: OrgBusinessPartnerBasicInfo | undefined;
    hasMoreBusinessPartner?: boolean;
}

export interface Contact {
    phoneNumber?: string | undefined;
    faxNumber?: string | undefined;
    email?: string | undefined;
}

export interface ElectronicAddressModel {
    electronicAddress?: string | undefined;
}

export interface BankAccountBasicInfo {
    accountNumber?: string | undefined;
    swift?: string | undefined;
    currencyCode?: string | undefined;
}

export interface BankAccountBasicInfoWithType extends BankAccountBasicInfo {
    type?: string | undefined;
}

export interface BankAccountMoreInfoWithType extends BankAccountBasicInfoWithType {
    hasMore?: boolean;
}

export interface OrgBusinessPartnerBasicInfo {
    nip?: string | undefined;
    fullName?: string | undefined;
}

export interface UserOrganizationBusinessPartnersQuery_QueryResult {
    businessPartner?: BusinessPartner2[] | undefined;
}

export interface OrganizationMemberBase {
    wip: number;
    pesel?: string | undefined;
    nip?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
}

export interface BusinessPartner2 extends OrganizationMemberBase {
    typeOfEntity?: string | undefined;
    displayName?: string | undefined;
    fullName?: string | undefined;
    companyName?: string | undefined;
    dateOfBirth: string;
    regon?: string | undefined;
}

export interface UserOrganizationAddressesQuery_QueryResult {
    addresses?: Address[] | undefined;
}

export interface UserOrganizationAddressesCitiesQuery_QueryResult {
    citiesNames?: string[] | undefined;
}

export interface UserOrganizationBankAccountsQuery_QueryResult {
    bankAccounts?: BankAccount[] | undefined;
}

export interface UserOrganizationBankAccountsCurrenciesQuery_QueryResult {
    currencyCodes?: string[] | undefined;
}

export interface ValidateTaxIdQuery_QueryResult {
    isTaxIdValid?: boolean;
}

export interface ValidateTaxIdQuery_Query {
    taxId?: string | undefined;
    taxIdType: TaxIdType;
    scope: LimiterScope;
}

export enum TaxIdType {
    NIP = 0,
    PESEL = 1,
    WIP = 2,
    EtollLogin = 3,
}

export enum LimiterScope {
    User = 0,
    EForms = 1,
    TaxApplications = 2,
    TaxPayerReport = 3,
    SmallMediumEnterprise = 4,
    Delivery = 5,
    Documents = 6,
    Agreements = 7,
    Ewis = 8,
    Subject = 9,
    DelegationProxyValidation = 10,
}

export interface BankAccountsForDocumentQuery_QueryResult {
    userDocumentBankAccounts?: DocumentBankAccount[] | undefined;
}

export interface DocumentBankAccount {
    searchDisplayName?: string | undefined;
}

export interface BankAccountsForDocumentQuery_Query {
    searchPhrase?: string | undefined;
    pagingOptions?: PagingOptions | undefined;
}

export interface PagingOptions {
    pageSize?: number | undefined;
    pageNumber?: number | undefined;
}

export interface ValidateUserQuery_QueryResult {
    isValid?: boolean;
    validationErrors?: UserValidationError[] | undefined;
    remainingAttempts: number;
}

export enum UserValidationError {
    None = 0,
    TaxIdNotValid = 1,
    FirstNameNotValid = 2,
    LastNameNotValid = 3,
    IsNotAlive = 4,
    UserBlocked = 5,
    IsNotAdult = 6,
    DateOfBirthNotValid = 7,
}

export interface ValidationErrorResult {
    errors?: { [key: string]: string[]; } | undefined;
    status: number;
    traceId?: string | undefined;
    title?: string | undefined;
    subStatus?: string | undefined;
}

export interface ValidateUserQuery_Query {
    taxId?: string | undefined;
    taxIdKind: IdentifierKind;
    scope: LimiterScope;
    firstName?: string | undefined;
    lastName?: string | undefined;
    checkIsAdult?: boolean;
    dateOfBirth?: string | undefined;
}

export enum IdentifierKind {
    None = 0,
    P = 1,
    N = 2,
    R = 3,
    K = 4,
    W = 5,
}

export interface UserLoginMethodQuery_QueryResult {
    name?: string | undefined;
    label?: string | undefined;
    enabled?: boolean;
    canChange?: boolean;
    description?: string | undefined;
}

export interface UserLoginMethodUpdate_CommandResult extends TranslatedCommandResult {
    result?: string | undefined;
}

export interface UserLoginMethodUpdate_Command {
    name: string;
    enabled: boolean;
}

export interface UserCheckAuthorization_CommandResult2 {
    isAuthorized?: boolean;
    authErrorCode?: UserCheckAuthorization_AuthErrorCode | undefined;
}

export enum UserCheckAuthorization_AuthErrorCode {
    None = 0,
    NotAlive = 1,
    NotAdult = 2,
    NotExistsInCrp = 3,
    NotLoggedInWithEnabledMethod = 4,
    Informal = 5,
    TaxDataInformal = 6,
    UserWithoutPesel = 7,
    DataInconsistency = 8,
}

export interface MobileUpdateShortcuts_CommandResult {
    isSuccess?: boolean;
}

export interface MobileUpdateShortcuts_Command {
    userShortcuts: string[];
    organizationShortcuts?: string[] | undefined;
}

// << Types end

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}
